'use client';

import type { ReactNode } from 'react';
import type { SelectedPersonalization } from './types';

interface ExposureTrackerProps {
  /** Experiment selection for this module, if it participates in an experiment */
  exposure?: SelectedPersonalization;
  /** Contentful sys.id of the module being tracked */
  moduleId: string;
  children: ReactNode;
}

/**
 * Wraps a resolved module and fires an exposure event when it enters the viewport.
 * Stub implementation — EVOLUTION-2986 will add intersection-observer tracking.
 */
export const ExposureTracker = ({ children }: ExposureTrackerProps) => {
  return <>{children}</>;
};
